import { Disclosure, DisclosureButton } from "@headlessui/react";
import { ReactNode } from "react";
import { SlideTransition } from "../../../../../components/transition/SlideTransition";

type StorefrontPromotionCollapsibleProps = {
  trigger: (args: { open: boolean }) => ReactNode;
  renderOnlyChildren?: boolean;
  defaultOpen?: boolean;
  children: ReactNode;
};

export const StorefrontPromotionCollapsible = ({
  defaultOpen = false,
  trigger,
  children,
  renderOnlyChildren,
}: StorefrontPromotionCollapsibleProps) => {
  if (renderOnlyChildren) {
    return children;
  }

  return (
    <Disclosure as="div" defaultOpen={defaultOpen}>
      {({ open }) => (
        <>
          <DisclosureButton className="w-full text-left">
            {trigger({ open })}
          </DisclosureButton>
          <SlideTransition show={open} parentClass="duration-200 ease-out">
            {children}
          </SlideTransition>
        </>
      )}
    </Disclosure>
  );
};
